import React from 'react';

import Icon from './Base';
import { TYPES } from './constants';

const AllbirdsByNature = props => <Icon type={TYPES.AllBIRDS_BY_NATURE} {...props} />;
const AllbirdsLogo = props => <Icon type={TYPES.ALLBIRDS_LOGO} {...props} />;
const AmazonPay = props => <Icon type={TYPES.AMAZON_PAY} {...props} />;
const ApplePay = props => <Icon type={TYPES.APPLE_PAY} {...props} />;
const DownloadIcon = props => <Icon type={TYPES.DOWNLOAD} {...props} />;
const FiltersIcon = props => <Icon type={TYPES.FILTERS} {...props} />;
const GooglePay = props => <Icon type={TYPES.GOOGLE_PAY} {...props} />;
const HelpIcon = props => <Icon type={TYPES.HELP} {...props} />;
const InfoIcon = props => <Icon type={TYPES.INFO} {...props} />;
const LinkOutIcon = props => <Icon type={TYPES.LINK_OUT} {...props} />;
const NextCircleIcon = props => <Icon type={TYPES.NEXT_CIRCLE} {...props} />;
const PayPal = props => <Icon type={TYPES.PAY_PAL} {...props} />;
const PeaceIcon = props => <Icon type={TYPES.PEACE} {...props} />;
const PlayTriangle = props => <Icon type={TYPES.PLAY_TRIANGLE} {...props} />;
const PlayTriangleCircle = props => <Icon type={TYPES.PLAY_TRIANGLE_CIRCLE} {...props} />;
const PrevCircleIcon = props => <Icon type={TYPES.NEXT_CIRCLE} flipHorizontally {...props} />;
const SearchIcon = props => <Icon type={TYPES.SEARCH} {...props} />;
const SearchSkinnyIcon = props => <Icon type={TYPES.SEARCH_SKINNY} {...props} />;
const SearchWhiteIcon = props => <Icon type={TYPES.SEARCH_WHITE} {...props} />;
const ShopifyPay = props => <Icon type={TYPES.SHOPIFY_PAY} {...props} />;
const UserIcon = props => <Icon type={TYPES.USER} {...props} />;
const ZoomCircleIcon = props => <Icon type={TYPES.ZOOM_CIRCLE} {...props} />;

export {
  AllbirdsByNature,
  AllbirdsLogo,
  AmazonPay,
  ApplePay,
  DownloadIcon,
  FiltersIcon,
  GooglePay,
  HelpIcon,
  InfoIcon,
  LinkOutIcon,
  NextCircleIcon,
  PayPal,
  PeaceIcon,
  PlayTriangle,
  PlayTriangleCircle,
  PrevCircleIcon,
  SearchIcon,
  SearchSkinnyIcon,
  SearchWhiteIcon,
  ShopifyPay,
  UserIcon,
  ZoomCircleIcon,
};
